'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _BaoIconLoading = require('../../Icons/BaoIconLoading');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Button = function Button(_ref) {
  var _cn;

  var color = _ref.color,
      customColor = _ref.customColor,
      size = _ref.size,
      fullwidth = _ref.fullwidth,
      disabled = _ref.disabled,
      appearDisabled = _ref.appearDisabled,
      loading = _ref.loading,
      href = _ref.href,
      className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      onClick = _ref.onClick,
      props = (0, _objectWithoutProperties3.default)(_ref, ['color', 'customColor', 'size', 'fullwidth', 'disabled', 'appearDisabled', 'loading', 'href', 'className', 'style', 'children', 'onClick']);

  var Elem = href ? 'a' : 'button';
  var customColorStyle = customColor && { '--Button_Color': customColor };

  return _react2.default.createElement(Elem, (0, _extends3.default)({
    href: href,
    disabled: disabled,
    onClick: disabled ? function () {
      return null;
    } : onClick,
    className: (0, _classnames2.default)(className, (_cn = {}, (0, _defineProperty3.default)(_cn, 'btn-' + color, color), (0, _defineProperty3.default)(_cn, 'btn-' + size, size), (0, _defineProperty3.default)(_cn, 'btn-CustomColor', customColor), (0, _defineProperty3.default)(_cn, 'btn-FullWidth', fullwidth === true), (0, _defineProperty3.default)(_cn, 'btn-FullWidth-xs', fullwidth === 'xs'), (0, _defineProperty3.default)(_cn, 'btn-Loading', loading), (0, _defineProperty3.default)(_cn, 'btn-disabled', appearDisabled), _cn)),
    style: (0, _assign2.default)({}, style, customColorStyle)
  }, props), _react2.default.createElement('span', null, children), ' ', _react2.default.createElement('span', { className: 'btn-Icon_Loading', dangerouslySetInnerHTML: { __html: _BaoIconLoading.BaoIconLoading } }));
};

exports.Button = Button;
Button.defaultProps = {
  color: 'Primary',
  customColor: null,
  size: undefined,
  fullwidth: false,
  disabled: false,
  appearDisabled: false,
  loading: false,
  href: undefined,
  className: undefined,
  onClick: function onClick() {
    return null;
  }
};

Button.propTypes = {
  color: _propTypes2.default.oneOf(['Primary', 'Secondary', 'Tertiary', 'Quaternary']),
  size: _propTypes2.default.oneOf([undefined, 'Small', 'Large']),
  fullwidth: _propTypes2.default.oneOf([false, true, 'xs']),
  disabled: _propTypes2.default.bool,
  appearDisabled: _propTypes2.default.bool,
  href: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired
};